import * as React from 'react'

import CtaBanner from '../../components/CtaBanner/CtaBanner'
import type { CtaBannerViewModel } from '../../view-models/CtaBannerViewModel'
type Props = CtaBannerViewModel
type State = {}

class CtaBannerModule extends React.Component<Props, State> {
  static displayName = 'CtaBannerModule'
  static defaultProps = {}

  render() {
    return (
      <div id={this.props.id || ''}>
        <CtaBanner {...this.props} />
      </div>
    )
  }
}

export default CtaBannerModule